import { createRelayEnvironment } from '@atlassian/relay-environment';
import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import { getConfig, getReleaseVersion } from '@townsquare/config';
import { PRODUCT_DISPLAY_NAME } from '@townsquare/config/constants';

import { fetchGraphQLFromUrl, logMissingRequiredField } from './RelayEnvironment';
import { getAtlAttributionHeader } from './getAtlAttributionHeader';

// These types are prefixed with the AGG prefix to avoid conflicts with other types
const AGG_PREFIX_TYPES = [
	'SearchResultAtlasGoal',
	'SearchResultAtlasProject',
	'MercuryProviderWorkSearchItem',
	'GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge',
	'GraphStoreBatchFocusAreaHasAtlasGoalStartNode',
	'GraphStoreCypherQueryV2AriNode',
];

const getDataID = (fieldValue: any, typeName: string) => {
	if (AGG_PREFIX_TYPES.includes(typeName)) {
		return `${typeName}:${fieldValue.id}`;
	}

	return fieldValue.id;
};

const platformRelayEnvironment = createRelayEnvironment({
	requiredFieldLogger: logMissingRequiredField,
	getDataID,
	networkOptions: {
		isServer: false,
		// @deprecated Use getHeaders instead
		setOptions: ({ options, request, variables }) => ({
			...options,
			headers: {
				'atl-client-name': 'townsquare-frontend',
				'atl-client-version': getReleaseVersion(),
				...getAtlAttributionHeader(request, variables),
			},
		}),
		getHeaders: ({ request, variables }) => ({
			'atl-client-name': 'townsquare-frontend',
			'atl-client-version': getReleaseVersion(),
			...getAtlAttributionHeader(request, variables),
		}),
	},
});

const aggExperimentalConfig = getConfig();
const EXPERIMENTAL_JIRA_API_HEADER = { 'X-ExperimentalApi': 'JiraIssueSearch' };

export const AggExperimentalJiraRelayEnvironment = new Environment({
	configName: `${PRODUCT_DISPLAY_NAME} AGG GraphQL Experimental`,
	network: Network.create(
		fetchGraphQLFromUrl({
			defaultUrl: aggExperimentalConfig.aggGraphQLUrl,
			multiRegionUrl: undefined,
			customHeaders: EXPERIMENTAL_JIRA_API_HEADER,
		}),
	),
	store: new Store(new RecordSource()),
	relayFieldLogger: logMissingRequiredField,
});

export function getAggRelayEnvironment(): Environment {
	return platformRelayEnvironment;
}
